import { render, staticRenderFns } from "./description.vue?vue&type=template&id=473e2d39&scoped=true"
import script from "./description.vue?vue&type=script&lang=ts"
export * from "./description.vue?vue&type=script&lang=ts"
import style0 from "./description.vue?vue&type=style&index=0&id=473e2d39&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473e2d39",
  null
  
)

export default component.exports